import {createFileRoute, redirect} from '@tanstack/react-router'
import {useContext, useEffect} from "react";
import {isAuthenticated} from "../../../utils/auth.ts";
import Layout from "../../../components/Layouts/Layout.tsx";
import {PatientsContext} from "../../../context/PatientsContext.tsx";
import PatientDetails from "../../../components/Patients/PatientDetails.tsx";

export const Route = createFileRoute('/patients/$patientId/')({
  beforeLoad: async () => {
    if(!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { patientId } = Route.useParams();
  const { setActivePatient } = useContext(PatientsContext);
  
  useEffect(() => {
    setActivePatient(Number(patientId));
  }, [patientId]);
  
  return (
    <Layout>
      <PatientDetails/>
    </Layout>
  );
}
